import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { SuccessCard } from '@identity/presentation/components/base';
import { PROFILE_ROUTE } from '@identity/presentation/constants';

/**
 * The screen that closes a phone verification started from Mi perfil.
 *
 * Entering the portal here means going back to the screen the user left, which is also the only
 * place that shows the number that just changed.
 */
export const PhoneVerifiedScreen = () => {
  const { t } = useTranslation('identity');
  const history = useHistory();

  return (
    <SuccessCard
      actionLabel={t('profile.phoneVerified.action')}
      description={t('profile.phoneVerified.body')}
      onAction={() => history.replace(PROFILE_ROUTE)}
      title={t('profile.phoneVerified.title')}
    />
  );
};
